import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ActivatedRoute, CanActivateFn, Router, UrlTree, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import { UserService } from '@services/user.service';
import { Console } from '../../shared/providers/custom-logger';
import { UserRepository } from '../services/user.repository.service';
import { AppStore } from '@services/store/app.store';

export const introGuard: CanActivateFn = (): boolean => {
  const router = inject(Router);
  const appStore = inject(AppStore);
  const hasSeenIntro = appStore.hasSeenIntro();

  if (hasSeenIntro) {
    return true;
  } else {
    router.navigateByUrl('/intro', { replaceUrl: true });
    return false;
  }
};

export const userVerifiedGuard: CanActivateFn = (): boolean => {
  const router: Router = inject(Router);
  const appStore = inject(AppStore);
  
  Console.log('userVerifiedGuard: utente attivo ', appStore.isAuthenticated());
  
  if (!appStore.isAuthenticated()) {
    router.navigate(['/login'], { replaceUrl: true });
    return false;
  }

  const currentUser = appStore.user();

  if (currentUser && appStore.isAuthenticated()) {
    return true;
  }

  // Only redirect to /app/utente if we're not already there
  if (!router.url.includes('/app/utente')) {
    router.navigate(['/app/utente'], { replaceUrl: true });
  }
  return false;
};

export const ruoloManifestazioneAbilitatoGuard: CanActivateFn = ():
  | boolean
  | UrlTree => {
    const router = inject(Router);
    const userService = inject(UserService);

    const currentUser = userService.getCurrentUser();
    
    Console.log(
      'ruoloManifestazioneAbilitatoGuard:',
      currentUser && userService.isIscritto('manifestazione')
    );
    if (currentUser && userService.isIscritto('manifestazione')) {
      return true;
    } else {
      return router.createUrlTree(['/app/manifestazione-page']);
    }
};

export const ruoloPromotoreAbilitatoGuard: CanActivateFn = ():
  | boolean
  | UrlTree => {
    const router = inject(Router);
    const userService = inject(UserService);
    
    Console.log(
      'ruoloPromotoreAbilitatoGuard:',
      userService.isIscritto('promotore')
    );
    if (userService.isIscritto('promotore')) {
      return true;
    } else {
      return router.createUrlTree(['/app/promotore-page']);
    }};

export const ruoloConvenzionatoAbilitatoGuard: CanActivateFn = ():
  | boolean
  | UrlTree => {
    const router = inject(Router);
    const userService = inject(UserService);
    
    Console.log(
      'ruoloConvenzionatoAbilitatoGuard:',
      userService.isIscritto('convenzionato')
    );
    if (userService.isIscritto('convenzionato')) {
      return true;
    } else {
      return router.createUrlTree(['/app/convenzionato-page']);
    }};

export const botPageGuard: CanActivateFn = ():
  | boolean
  | UrlTree => {
    const router = inject(Router);
    const appStore = inject(AppStore);
    
    Console.log('botPageGuard', 'controllo accesso alla pagina bot', 'std');
    
    if (appStore.isAuthenticated()) {
      return true;
    } else {
      router.navigate(['/login'], { replaceUrl: true });
      return false;
    }
  };

export const routesGuard: CanActivateFn = (): boolean => {
  const router = inject(Router);
  const userRepository = inject(UserRepository);
  const currentUser = userRepository.getUser();

  Console.log('routesGuard: utente attivo ', currentUser.isAuthenticated());

  if (!currentUser || !currentUser.isAuthenticated()) {
    router.navigate(['/login'], { replaceUrl: true });
    return false;
  }
  else {
    return true;
  }

  // if (!currentUser || !currentUser.isVerified()) {
  //   router.navigate(['/app/utente'], { replaceUrl: true });
  //   return false;
  // }

  return true;
};

export function canActivate(
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
  const userRepository = inject(UserRepository);
  const router = inject(Router);
  const currentUser = userRepository.getUser();

  if (!currentUser || !currentUser.isAuthenticated()) {
    router.navigate(['/login'], { replaceUrl: true });
    return false;
  }

  if (!currentUser || !currentUser.isVerified()) {
    router.navigate(['/app/utente'], { replaceUrl: true });
    return false;
  }

  return true;
}

@Injectable({
  providedIn: 'root',
})
export class RoutesGuard {
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const userRepository = inject(UserRepository);
    const router = inject(Router);
    const currentUser = userRepository.getUser();

    if (!currentUser || !currentUser.isAuthenticated()) {
      router.navigate(['/login'], { replaceUrl: true });
      return false;
    }

    if (!currentUser || !currentUser.isVerified()) {
      router.navigate(['/app/utente'], { replaceUrl: true });
      return false;
    }

    return true;
  }
}
